<template>
  <el-breadcrumb class="app-breadcrumb" separator="/" v-if="path!='/'" :style="{width:path=='/newsdetail'?'800px':'1200px'}">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path" class="asss">
        <i class="el-icon-s-home" style="font-size: 16px;cursor: pointer;" v-if="item.path=='/'"></i>
		<a @click.prevent="handleLink(item)" style="cursor: pointer;">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
const pathToRegexp = require('path-to-regexp');
export default {
  data() {
    return {
      levelList: null,
	  path:"/"
    }
  },
  watch: {
    $route(route) {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
		this.path = this.$route.path
	  //获取当前的路由
      let matched = [
		  {
			  path:this.$route.fullPath,
			  meta:this.$route.meta,
			  query:this.$route.query
		  }
	  ];
	 const first = matched[0]
      if (!this.isDashboard(first)) {
        matched = [{ path: '/', meta: { title: '门户首页' }}].concat(matched)
      }
      let newArr = [];
	  let obj = {};
	  for (var i = 0; i < matched.length; i++) {
		 if (!obj[matched[i].meta.title]) {
		   newArr.push(matched[i])
		   obj[matched[i].meta.title] = true
		 }
	  }
	  console.log("newarr",newArr);
	  newArr.forEach(r=>{
		  if(r.path=='/newslist?type=2'){
			  r.meta.title = '资源列表'
		  }
		  if(r.path=='/newslist?type=3'){
		  	  r.meta.title = '公告列表'
		  }
		  if(r.path=="/huanjinglist?type=1"){
			  r.meta.title = '公开参观环境列表'
		  }
		  if(r.path=="/huanjinglist?type=2"){
		  	r.meta.title = '技术验证环境'
		  }
		  if(r.path=="/huanjinglist?type=3"){
		  	r.meta.title = '共享开发环境'
		  }
		  if(r.path=="/huanjinglist?type=4"){
		  	r.meta.title = '专享开发环境'
		  }
	  })
	  this.levelList = newArr;
	},
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'index'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const params = this.$route.fullPath
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { path } = item
	  //如果是当前页面路由 则刷新页面
	  if(this.$route.fullPath==path){
		  window.location.reload();
	  }else{
		  this.$router.push(this.pathCompile(path))
	  }
      
    }
  }
}
</script>

<style lang="scss" scoped>
	.asss i:hover{
		color: #409EFF!important;
	}
	.asss a:hover{
		color: #409EFF!important;
	}
	.app-breadcrumb{
		width: 1200px;
		margin: 0 auto;
	}
.app-breadcrumb.el-breadcrumb {
  display: block;
  font-size: 14px;
  line-height: 50px;
  padding-left: 10px;
  // box-shadow: 0px 0px 5px #e5e5e5;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue